export const MEMBER_DETAIL = 'MEMBER_DETAIL'
export const SCAN_CODE = 'SCAN_CODE'
export const CANCEL_TYPE_OPTIONS = 'CANCEL_TYPE_OPTIONS'
export const MEMBER_CAR_ATTRIBUTION = 'MEMBER_CAR_ATTRIBUTION'
export const EMPTY_QR_CODE = 'EMPTY_QR_CODE'
export const FINANCIAL_PROJECT_INSTANCE = 'FINANCIAL_PROJECT_INSTANCE'
export const STORED_VALUE_RECORD = 'STORED_VALUE_RECORD'
export const CAR_BRAND_OPTIONS = 'CAR_BRAND_OPTIONS'
export const CAR_TYPE_NAME_OPTIONS = 'CAR_TYPE_NAME_OPTIONS'
export const MARITAL_STATUS = 'MARITAL_STATUS'
export const TYPE_OCCUPATION = 'TYPE_OCCUPATION'
export const TYPE_HOBBY = 'TYPE_HOBBY'
export const TYPE_VEHICLE_USE = 'TYPE_VEHICLE_USE'



// WEBPACK FOOTER //
// ./src/pages/wx-member/member/store/mutations-types.js